import { RootState } from '@cp/src/store';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '@cp/src/components/Loader/Loader';
import { approveOrRejectApproval } from '../../actions/ApprovalsActions';
import { EntityType, PENDING_APPROVALS_KEY, initialPaginationParams } from '../../constant';
import PanCard from './PanCard';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { useEffect } from 'react';

const SelectedPanCard = () => {
  const approvalOrRejectionInProgress = useSelector(
    (state: RootState) => state.approvals.approvalOrRejectionInProgress
  );
  const selectedApprovalItem = useSelector(
    (state: RootState) => state.approvals.selectedPanApprovalItem
  );
  const { [PENDING_APPROVALS_KEY]: queryParams } = readQueryParams();

  const dispatch = useDispatch();

  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_PAN_CARD_LOADED, {
      approvalItem: selectedApprovalItem?.referenceId,
      agentId: selectedApprovalItem?.data?.agentReferenceId
    });
  }, []);

  const handleApproval = () => {
    if (selectedApprovalItem) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_CLICKED_PAN_CARDS_APPROVED, {
        approvalItem: selectedApprovalItem?.referenceId,
        agentId: selectedApprovalItem?.data?.agentReferenceId
      });
      const payload = {
        approvalRequestId: selectedApprovalItem.referenceId,
        comment: '',
        approve: true
      };
      const params = queryParams
        ? { ...initialPaginationParams, ...queryParams }
        : initialPaginationParams;
      dispatch(
        approveOrRejectApproval(payload, { ...params, entityType: EntityType.AGENT_PAN_CARD })
      );
    }
  };

  const handleRejection = (comment: string) => {
    if (selectedApprovalItem) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_CLICKED_PAN_CARDS_REJECT, {
        approvalItem: selectedApprovalItem?.referenceId,
        agentId: selectedApprovalItem?.data?.agentReferenceId
      });
      const payload = {
        approvalRequestId: selectedApprovalItem.referenceId,
        comment,
        approve: false
      };
      const params = queryParams
        ? { ...initialPaginationParams, ...queryParams }
        : initialPaginationParams;
      dispatch(
        approveOrRejectApproval(payload, { ...params, entityType: EntityType.AGENT_PAN_CARD })
      );
    }
  };

  return (
    <>
      <PanCard handleApproval={handleApproval} handleRejection={handleRejection} />
      <Loader show={approvalOrRejectionInProgress} className={'overlay'} animate={false} />
    </>
  );
};

export default SelectedPanCard;
